import React from "react";
import ChallengeResponseForm from "../../../widgets/ChallengeResponseForm";
import { KIND_EXPIRED, MESSAGES } from "../../../auth/challengeErrors";
import "../QrCodeGenerator/index.css";

// Response step of the QR login: same form as the ID login once the session is paired.
const Component = ({ actions, loginInformation, attemptError, sessionInformation }) => {
  const fullName = sessionInformation
    ? [sessionInformation.firstName, sessionInformation.lastName].filter(Boolean).join(" ")
    : "";
  return (
    <>
      {fullName && <h3 style={{ textAlign: "center" }}>{`Bonjour ${fullName}`}</h3>}
      <ChallengeResponseForm
        loginInformation={loginInformation}
        attemptError={attemptError}
        onSubmit={(response) =>
          actions.checkChallenge(loginInformation.challengeId, loginInformation.userId, response)
        }
        onExpire={() => actions.setRefusal({ kind: KIND_EXPIRED, message: MESSAGES[KIND_EXPIRED] })}
      />
    </>
  );
};

export default Component;
